// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"carousel-module--carouselWrapper--3nfvc","dotList":"carousel-module--dotList--2PsjP"};